import VideoPlaylist from './video-playlist';

// Slick options common to all contexts.
const slickOptionsCommon = {
  mobileFirst: true,
  adaptiveHeight: true,
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToScroll: 1,
};

const videoPlaylistConfig = {
  name: 'videoPlaylist',
  class: VideoPlaylist,
  querySelector: {
    articleContent: '.article-list__content',
    playerEl: '.video-playlist__player [id^="player"]',
    playerWrapper: '.video-playlist__player',
  },
  querySelectorAll: {
    articles: '.article-list__article',
    articleTitles: '.article-list__article-title',
  },
  options: {
    playingClass: 'now-playing',
    upNextClass: 'up-next',
    iconTextClass: 'article-list__article-mediaicon-text',
    slickOptions: {
      ...slickOptionsCommon,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1,
          settings: {
            slidesToShow: 2.25,
          },
        },
      ],
    },
    slickOptionsSidebar: {
      ...slickOptionsCommon,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1,
          settings: {
            slidesToShow: 2.25,
          },
        },
      ],
    },
  },
};

export default videoPlaylistConfig;
